/**
 * Mixpanel Service Constants
 * All configuration values and magic numbers for Mixpanel tracking
 */

export { CheckoutEntryPath, CheckoutSource } from '@monorepo/types';

/**
 * Page view tracking configuration
 */
export const PAGE_VIEW_CONSTANTS = {
  /** Debounce window (in milliseconds) to prevent duplicate page_view events */
  DEBOUNCE_MS: 500,
} as const;

/**
 * SessionStorage keys for Mixpanel
 */
export const MIXPANEL_STORAGE_KEYS = {
  /** Key for storing auth method across SSO redirects */
  AUTH_METHOD: 'mixpanel_auth_method',
  /** Key for storing checkout entry path (new_order, resume_explicit, resume_implicit) */
  CHECKOUT_ENTRY_PATH: 'mixpanel_checkout_entry_path',
  /** Key for storing checkout session ID (unique per checkout attempt) */
  CHECKOUT_SESSION_ID: 'mixpanel_checkout_session_id',
  /** Key for storing checkout source (cart_widget, orders_page) */
  CHECKOUT_SOURCE: 'mixpanel_checkout_source',
} as const;

/**
 * Mixpanel console log prefixes for mock mode
 */
export const MIXPANEL_LOG_PREFIXES = {
  INIT: '🔵 [Mixpanel MOCK] init:',
  IDENTIFY: '🟢 [Mixpanel MOCK] identify:',
  TRACK: '🟡 [Mixpanel MOCK] track:',
  PEOPLE_SET: '🟣 [Mixpanel MOCK] people.set:',
  PEOPLE_SET_ONCE: '🟠 [Mixpanel MOCK] people.set_once:',
  REGISTER: '🔴 [Mixpanel MOCK] register:',
  ALIAS: '🔗 [Mixpanel MOCK] alias:',
  RESET: '🔄 [Mixpanel MOCK] reset',
} as const;
